import {useState, useEffect} from 'react';

const MEDIA_QUERIES = {
  desktop: '(min-width: 1200px)',
  tablet: '(min-width: 768px) and (max-width: 1199px)',
  mobile: '(max-width: 767px)',
};

function useMediaQuery() {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia(MEDIA_QUERIES.mobile).matches,
  );
  const [isTablet, setIsTablet] = useState(
    window.matchMedia(MEDIA_QUERIES.tablet).matches,
  );
  const [isDesktop, setIsDesktop] = useState(
    window.matchMedia(MEDIA_QUERIES.desktop).matches,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia(MEDIA_QUERIES.mobile).matches);
      setIsTablet(window.matchMedia(MEDIA_QUERIES.tablet).matches);
      setIsDesktop(window.matchMedia(MEDIA_QUERIES.desktop).matches);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {isMobile, isTablet, isDesktop};
}

export default useMediaQuery;
